import Triangle from "./SVG/triangle.svg?react";

const TriangleIcon = () => {
  return <Triangle />;
};

export default TriangleIcon;
